
import { defineComponent } from 'vue';
import utils from '@/utils';
import api, { ISubmitRequest, IUploadResult } from '@/api/my/tickets';
import { IElForm } from '@/types/element';
import { TicketPriority } from '@/types/enums';
import { auth } from '@/store';

interface IFile {
  name: string;
  url: string;
}

interface IState {
  form: ISubmitRequest;
  loading: boolean;
  uploadToken: string;
  uploadUrl: string;
  fileList: IFile[];
}

export default defineComponent({
  name: 'TicketAdd',
  data() {
    return {
      hostIds: [],
      themeIds: [],
      extensionIds: [],
      form: {
        priority: TicketPriority.Normal,
        category: '',
        resourceId: '',
        content: '',
        fileUrls: [],
      },
      loading: false,
      uploadToken: auth.token,
      uploadUrl: api.getUploadUrl(),
      fileList: [],
    } as IState;
  },
  methods: {
    getAllTicketPriority() {
      return Object.values(TicketPriority);
    },

    getTicketPriority(priority: TicketPriority) {
      return utils.getTicketPriority(priority);
    },

    btnSubmitClick() {
      const form = this.$refs.form as IElForm;
      form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.form.fileUrls = [];
          for (const file of this.fileList) {
            this.form.fileUrls.push(file.url);
          }
          api.submit(this.form, (res) => {
            if (!res.value) return;
            utils.success('工单提交成功！');
            this.$emit('close', true);
          });
        }
      });
    },

    handleRemove(file: IFile) {
      this.fileList.splice(this.fileList.indexOf(file), 1);
    },

    handlePreview(file: IFile) {
      window.open(file.url);
    },

    uploadBefore(file: {name: string; size: number }) {
      const re = /(\.jpg|\.png)$/i;
      if (!re.exec(file.name)) {
        utils.error('截图只能是图片格式，请选择有效的文件上传!');
        return false;
      }

      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        utils.error('文件大小不能超过 10MB!');
      }
      return isLt10M;
    },

    uploadProgress() {
      utils.loading(true);
    },

    uploadSuccess(res: IUploadResult) {
      this.fileList.push(res);
      utils.loading(false);
    },

    uploadError(err: { message: string }) {
      utils.loading(false);
      const error = JSON.parse(err.message);
      utils.error(error.message);
    },

    btnCancelClick() {
      this.$emit('close', false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      const form = this.$refs.form as IElForm;
      form.resetFields();
      form.clearValidate();
    });
  },
});
